import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { BrokerComponent } from './broker/broker.component';
import { ExchangeComponent } from './exchange/exchange.component';
import { FeesPageComponent } from './fees/fees-page/fees-page.component';
import { LogoutComponent } from './logout/logout.component';
import { SupportPageComponent } from './support-page/support-page.component';
import { SupportModule } from '../support/support.module';
import { PageComponent } from './page/page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { EmailsUnsubscribeComponent } from './emails-unsubscribe/emails-unsubscribe.component';
import { VerifyIpAddressComponent } from './verify-ip-address/verify-ip-address.component';
import { NoWalletComponent } from './no-wallet/no-wallet.component';
import { FrontComponentsModule } from '../front-components/front-components.module';
import { PricesPageComponent } from './prices-page/prices-page.component';
import { CryptoPageComponent } from './crypto-page/crypto-page.component';
import { AuthComponentsModule } from '../auth-components/auth-components.module';
import { GeneralModule } from '../general/general.module';
import { RouterModule } from '@angular/router';
import { AffiliateProgramComponent } from './affiliate-program/affiliate-program.component';
import { PipesModule } from '../pipes/pipes.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { TradingCompetitionComponent } from './trading-competition/trading-competition.component';
import { InviteAndEarnCompetitionComponent } from './invite-and-earn-competition/invite-and-earn-competition.component';
import { MetaModule } from '../meta/meta.module';
import { OtcPageComponent } from './otc-page/otc-page.component';
import { FeesTabsComponent } from './fees/fees-tabs/fees-tabs.component';
import { SupportedTokensComponent } from './supported-tokens/supported-tokens.component';
import { FeesTradingComponent } from './fees/fees-trading/fees-trading/fees-trading.component';
import { FeesFiatComponent } from './fees/fees-fiat/fees-fiat.component';
import { FeesTableComponent } from './fees/fees-trading/fees-table/fees-table.component';
import { FeesCryptoComponent } from './fees/fees-crypto/fees-crypto.component';
import { TradingChartPageComponent } from './trading-chart-page/trading-chart-page.component';
import { VipPageComponent } from './vip-page/vip-page.component';

@NgModule({
  imports: [
    CommonModule,
    GeneralModule,
    PipesModule,
    RouterModule,
    FrontComponentsModule,
    AuthComponentsModule,
    SupportModule,
    MetaModule
  ],
  declarations: [
    HomeComponent,
    ResetPasswordComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    BrokerComponent,
    ExchangeComponent,
    FeesPageComponent,
    SupportedTokensComponent,
    FeesTabsComponent,
    LogoutComponent,
    SupportPageComponent,
    PageComponent,
    PageNotFoundComponent,
    EmailsUnsubscribeComponent,
    VerifyIpAddressComponent,
    NoWalletComponent,
    PricesPageComponent,
    CryptoPageComponent,
    AffiliateProgramComponent,
    AboutUsComponent,
    TradingCompetitionComponent,
    InviteAndEarnCompetitionComponent,
    OtcPageComponent,
    FeesTableComponent,
    FeesTradingComponent,
    FeesFiatComponent,
    FeesCryptoComponent,
    TradingChartPageComponent,
    VipPageComponent
  ]
})
export class FrontModule { }
